angular.module('directives', [])

angular
  .module('directives')
  .directive('memberFilter', ['Member', 'Field', 'Group', 'Invoice', '$rootScope', '$http', '$timeout', function (Member, Field, Group, Invoice, $rootScope, $http, $timeout) {
    return {
      restrict: 'A',
      transclude: true,
      replace: true,
      templateUrl: '/r/static/templates/filter.html',
      link: function (scope, element, attrs) {
        var actionTimer

        scope.filter_label = attrs.filterLabel || 'filter_show_persons_who_are'
        scope.disallow_inactives = attrs.disallowInactives === 'true' || false

        var verbs = [
          {
            label: 'verb_contains',
            name: 'icontains',
            for: {text: true, email: true, textarea: true},
          },
          {
            label: 'verb_does_not_contain',
            name: '!icontains',
            for: {text: true, email: true, textarea: true},
          },
          {
            label: 'verb_is',
            name: 'exact',
            for: {text: true, email: true, textarea: true},
          },
          {
            label: 'verb_is_not',
            name: '!exact',
            for: {text: true, email: true, textarea: true},
          },
          {
            label: 'verb_starts_with',
            name: 'istartswith',
            for: {text: true, email: true, textarea: true},
          },

          {
            label: 'verb_on_or_before',
            name: 'lte',
            for: {date: true},
          },
          {
            label: 'verb_on_or_after',
            name: 'gte',
            for: {date: true},
          },
          {
            label: 'verb_a4daterange',
            name: 'a4daterange',
            for: {date: true},
          },
          {
            label: 'verb_equals',
            name: 'exact',
            for: {integer: true, decimal: true},
          },
          {
            label: 'verb_gte',
            name: 'gte',
            for: {integer: true, decimal: true},
          },
          {
            label: 'verb_lte',
            name: 'lte',
            for: {integer: true, decimal: true},
          },

          // is empty / is not empty: always the lowermost verbs in the UI list
          {
            label: 'verb_is_empty',
            name: 'a4isempty',
            for: {text: true, email: true, textarea: true, password: true, integer: true, decimal: true, date: true},
            unary: true,
          },
          {
            label: 'verb_is_not_empty',
            name: '!a4isempty',
            for: {text: true, email: true, textarea: true, password: true, integer: true, decimal: true, date: true},
            unary: true,
          },
          {
            label: 'verb_is',
            name: 'a4boolequals',
            for: {checkbox: true}, // 'group': true?
          },
          {
            label: 'verb_a4isoneof',
            name: 'a4isoneof',
            for: {multiselect: true, multiautocomplete: true},
          },
          {
            label: 'verb_a4isnotanyof',
            name: '!a4isoneof',
            for: {multiselect: true, multiautocomplete: true},
          },
          {
            label: 'verb_a4ismemberofgroup',
            name: 'a4ismemberofgroup',
            for: {dummy: true},
          },
          {
            label: 'verb_a4isnotmemberofgroup',
            name: '!a4ismemberofgroup',
            for: {dummy: true},
          },
          {
            label: 'verb_a4membercardstatus',
            name: 'a4membercardstatus',
            for: {dummy: true},
          },
          {
            label: 'verb_a4invoicestatus',
            name: 'a4invoicestatus',
            for: {dummy: true},
          },
        ]

        scope.conditions = []
        scope.pageSize = $rootScope.session.get_persistent_data('MemberPageSize') || 20
        scope.fieldHash = {}

        $rootScope.pageSizeOptions = [
          {title: 20, number: 20},
          {title: 50, number: 50},
          {title: 100, number: 100},
          {title: _('members_everyone'), number: 100000},
        ]

        scope.setPageSize = function (size) {
          scope.pageSize = size
          $rootScope.session.set_persistent_data('MemberPageSize', size.toString())
          scope.numberOfPages = Math.ceil(scope.members.length / scope.pageSize)
          scope.currentPage = 0
          $rootScope.last_page = null
        }

        // Membercols is an array of field names which are displayed in the member list. Defaults to fullname, email and phone (sms)
        var _savedCols = $rootScope.session.get_persistent_data('MemberCols')
        if (_savedCols) {
          scope.membercols = _savedCols.split(',')
        } else {
          scope.membercols = ['email', 'phone']
        }

        // Sorting state. Persisted under a configurable key so that views embedding this
        // directive more than once (e.g. members list vs. member applications) can each
        // remember their own sort order instead of sharing one.
        var sortPersistKey = attrs.sortPersistKey || 'MemberSort'
        var _savedSort = $rootScope.session.get_persistent_data(sortPersistKey)
        if (_savedSort) {
          var parts = _savedSort.split(',')
          scope.sortField = parts[0]
          scope.sortReverse = parts[1] === 'desc'
        } else {
          scope.sortField = 'fullname_reverse_'
          scope.sortReverse = false
        }

        scope.sortBy = function (field) {
          if (scope.sortField === field) {
            scope.sortReverse = !scope.sortReverse
          } else {
            scope.sortField = field
            scope.sortReverse = false
          }
          $rootScope.session.set_persistent_data(
            sortPersistKey,
            scope.sortField + ',' + (scope.sortReverse ? 'desc' : 'asc'),
          )
          scope.applySorting()
          scope.currentPage = 0
        }

        scope.applySorting = function () {
          if (!scope.members) return
          var fieldType = scope.fieldHash[scope.sortField] ? scope.fieldHash[scope.sortField].type : null
          var isNumeric = fieldType === 'integer' || fieldType === 'decimal'
          scope.members.sort(function (a, b) {
            var valA = scope.getColumnValue(a, scope.sortField)
            var valB = scope.getColumnValue(b, scope.sortField)
            if (valA == null) valA = ''
            if (valB == null) valB = ''
            if (isNumeric) {
              valA = valA === '' ? -Infinity : parseFloat(valA)
              valB = valB === '' ? -Infinity : parseFloat(valB)
            } else if (typeof valA === 'string') {
              valA = valA.toLowerCase()
              valB = ('' + valB).toLowerCase()
            }
            if (valA < valB) return scope.sortReverse ? 1 : -1
            if (valA > valB) return scope.sortReverse ? -1 : 1
            return 0
          })
        }
        scope.coloptions = []

        scope.$watch(
          'membercols',
          function () {
            $rootScope.session.set_persistent_data('MemberCols', scope.membercols.toString())
          },
          true,
        )

        scope.fields = null
        scope.groups = null
        scope.invoices = null

        // Load all dependancies from the server that we need to populate filters, and watch below
        Field.query(
          {id: 'all'},
          function (data) {
            scope.fields = data
          },
          a4.restErrorFactory(scope),
        )

        Group.query(
          {id: 'all'},
          function (data) {
            scope.groups = data
          },
          a4.restErrorFactory(scope),
        )

        Invoice.query(
          {
            id: 'all',
            dashboard: false,
          },
          function (data) {
            scope.invoices = data.invoices
          },
          a4.restErrorFactory(scope),
        )

        // After all dependencies have loaded, sort everything out
        // Pass true as 3rd parameter to $watch() to make it check values and not just variable references.

        var watcher = scope.$watch(
          '[fields,groups,invoices]',
          function () {
            if (scope.fields && scope.groups && scope.invoices) {
              watcher() // Unregister the watch so we don't get an infinite loop

              scope.fields.push({
                label: _('field_uptodateness_email'),
                name: 'uptodateness_email_c',
                type: 'multiselect',
                params: {htmlLabels: true},
                options: [
                  {
                    label:
                      '<span class="badge badge-success"><span class="glyphicon glyphicon-ok-circle"></span></span> ' +
                      _('filter_email_confirmed'),
                    value: 'confirmed',
                  },
                  {
                    label:
                      '<span class="badge badge-info"><span class="glyphicon glyphicon-circle-arrow-right"></span></span> ' +
                      _('filter_email_sent'),
                    value: 'sent',
                  },
                  {
                    label:
                      '<span class="badge badge-important"><span class="glyphicon glyphicon-remove-circle"></span></span> ' +
                      _('filter_email_bounced'),
                    value: 'bounced',
                  },
                  {
                    label:
                      '<span class="badge"><span class="glyphicon glyphicon-question-sign"></span></span> ' +
                      _('filter_email_unused'),
                    value: 'unused',
                  },
                  {
                    label:
                      '<span class="badge badge-warning"><span class="glyphicon glyphicon-warning-sign"></span></span> ' +
                      _('filter_email_missing'),
                    value: 'missing',
                  },
                ],
                group: _('field_group_quick'),
              })

              scope.fields.push({
                label: _('field_membercard_status'),
                name: 'membercardstatus',
                type: 'dropdown',
                params: {hideVerb: true},
                customVerb: 'a4membercardstatus',
                options: [
                  {
                    label: _('filter_membercard_has_been_sent'),
                    value: 'sent',
                  },
                  {
                    label: _('filter_membercard_has_not_been_sent'),
                    value: 'not_sent',
                  },
                ],
                group: _('field_group_quick'),
              })

              scope.fields.push({
                label: _('field_uptodateness_sms'),
                name: 'uptodateness_sms_c',
                type: 'multiselect',
                params: {htmlLabels: true},
                options: [
                  {
                    label:
                      '<span class="badge badge-success"><span class="glyphicon glyphicon-ok-circle"></span></span> ' +
                      _('filter_sms_confirmed'),
                    value: 'confirmed',
                  },
                  {
                    label:
                      '<span class="badge badge-info"><span class="glyphicon glyphicon-circle-arrow-right"></span></span> ' +
                      _('filter_sms_sent'),
                    value: 'sent',
                  },
                  {
                    label:
                      '<span class="badge badge-important"><span class="glyphicon glyphicon-remove-circle"></span></span> ' +
                      _('filter_sms_bounced'),
                    value: 'bounced',
                  },
                  {
                    label:
                      '<span class="badge"><span class="glyphicon glyphicon-question-sign"></span></span> ' +
                      _('filter_sms_unused'),
                    value: 'unused',
                  },
                  {
                    label:
                      '<span class="badge badge-warning"><span class="glyphicon glyphicon-warning-sign"></span></span> ' +
                      _('filter_sms_missing'),
                    value: 'missing',
                  },
                  {
                    label:
                      '<span class="badge badge-odd"><span class="glyphicon glyphicon-ban-circle"></span></span> ' +
                      _('filter_sms_unsupported'),
                    value: 'unsupported',
                  },
                ],
                group: _('field_group_quick'),
              })

              // Invoice payment status

              if (scope.invoices.length > 0) {
                scope.fields.unshift({
                  name: 'invoicestatus',
                  label: _('field_invoice_status'),
                  type: 'multiselect',
                  options: [
                    {
                      label: _('invoice_status_paid'),
                      value: 'paid',
                    },
                    {
                      label: _('invoice_status_pending'),
                      value: 'pending',
                    },
                    {
                      label: _('invoice_status_overdue'),
                      value: 'overdue',
                    },
                    {
                      label: _('invoice_status_underpaid'),
                      value: 'underpaid',
                    },
                    {
                      label: _('invoice_status_overpaid'),
                      value: 'overpaid',
                    },
                    {
                      label: _('invoice_status_not_sent'),
                      value: 'notsent',
                    },
                    // NON-LEGACY ONLY
                    {
                      label: _('invoice_status_credited'),
                      value: 'credited',
                    },
                    {
                      label: _('invoice_status_combosettled'),
                      value: 'combosettled',
                    },
                    // LEGACY ONLY
                    {
                      label: _('invoice_status_cancelled'),
                      value: 'cancelled',
                    },
                  ],
                  group: _('field_group_quick'),
                  customVerb: 'a4invoicestatus',
                  field_options: (function () {
                    var items = []
                    $.each(scope.invoices, function (i, v) {
                      items.push({
                        label: `${v.subject} (${_.date(v.date_sent)}, ${v.count_total_c} ${_('filter_recips_short')})`,
                        value: v.id,
                      })
                    })
                    return items
                  })(),
                  fieldOptionsMultiple: true,
                })
              }

              // Not a member of a group
              scope.fields.unshift({
                name: 'field_not_member_in_group',
                label: _('field_not_member_in_group'),
                type: 'multiselect',
                params: {},
                options: (function () {
                  var member_groups = []
                  $.each(scope.groups, function (i, v) {
                    member_groups.push({
                      label: v.label,
                      value: v.name,
                    })
                  })
                  return member_groups
                })(),
                group: _('field_group_groups'),
                customVerb: '!a4ismemberofgroup',
              })

              // Members in group
              scope.fields.unshift({
                name: 'field_member_in_group',
                label: _('field_member_in_group'),
                type: 'multiselect',
                params: {},
                options: (function () {
                  var member_groups = []
                  $.each(scope.groups, function (i, v) {
                    member_groups.push({
                      label: v.label,
                      value: v.name,
                    })
                  })
                  return member_groups
                })(),
                group: _('field_group_groups'),
                customVerb: 'a4ismemberofgroup',
              })

              scope.fields.push({
                label: _('field_date_created'),
                name: 'date_created',
                type: 'date',
                group: _('field_group_lifecycle'),
              })

              scope.fields.push({
                label: _('field_date_approved'),
                name: 'date_approved',
                type: 'date',
                group: _('field_group_lifecycle'),
              })

              if (attrs.deleted) {
                scope.fields.push({
                  label: _('field_date_deleted'),
                  name: 'date_deleted',
                  type: 'date',
                  group: _('field_group_lifecycle'),
                })
              }

              // Add the member filter to the front of the list so Basic filters appear first
              scope.fields.unshift({
                label: _('field_find_members'),
                name: 'id',
                type: 'multiautocomplete',
                group: _('field_group_quick'),
              })

              var _currentHeading

              for (var i = 0; i < scope.fields.length; i++) {
                var f = scope.fields[i]

                if (f.type == 'checkbox') {
                  f.options = [
                    {label: 'Checked', value: 'yes'},
                    {label: 'Unchecked', value: 'no'},
                  ]
                }

                // Set the current heading, if this is a heading
                if (scope.fields[i].type == 'heading') {
                  _currentHeading = scope.fields[i].label
                }

                if (_currentHeading && !scope.fields[i].group) {
                  scope.fields[i].group = _currentHeading
                } else if (!scope.fields[i].group) {
                  scope.fields[i].group = _('field_group_basic')
                }

                if ($rootScope.settings && $rootScope.settings.porg_enabled && scope.fields[i].name == 'email') {
                  scope.fields[i].label = _('fixedlabel_email_porg_main')
                }

                scope.fieldHash[f.name] = {
                  type: f.type,
                  options: f.options,
                  verbs: getVerbs(f.type, f.customVerb),
                  verbHash: getVerbHash(f.type, f.customVerb),
                  params: f.params || {},
                  field_options: f.field_options || [],
                  fieldOptionsMultiple: f.fieldOptionsMultiple || false,
                  label: f.label,
                }

                if ($.inArray(f.type, ['multiselect', 'multiautocomplete']) === -1 && f.type != 'heading') {
                  scope.coloptions.push({
                    label: f.label,
                    name: f.name,
                    group: scope.fields[i].group,
                  })
                }
              }

              // Membership lifecycle date fields: "on välillä" (a4daterange) should be the
              // default verb, so it must come first - getVerbs() would otherwise put it last.
              ;['date_created', 'date_approved', 'date_deleted'].forEach(function (fieldName) {
                if (scope.fieldHash[fieldName]) {
                  scope.fieldHash[fieldName].verbs = ['a4daterange', 'lte', 'gte']
                }
              })

              // date_approved can genuinely be empty (added directly, or applied but not yet
              // approved) - unlike date_created (always set) and date_deleted (always set once
              // removed) - so "on tyhjä"/"ei ole tyhjä" make sense here.
              if (scope.fieldHash['date_approved']) {
                scope.fieldHash['date_approved'].verbs.push('a4isempty', '!a4isempty')
              }

              scope.groupHash = {}

              $.each(scope.groups, function (i, v) {
                scope.groupHash[v.name] = {
                  label: v.label,
                }

                scope.coloptions.push({
                  label: v.label,
                  name: v.name,
                  group: _('field_group_groups'),
                })
              })

              // Check the current membercols for any old entries and remove them
              var len = scope.membercols.length
              var coloptionsArray = []
              $.each(scope.coloptions, function (i, v) {
                coloptionsArray.push(v.name)
              })
              while (len--) {
                if ($.inArray(scope.membercols[len], coloptionsArray) === -1) {
                  scope.membercols.splice(len, 1)
                }
              }

              // Hide heading fields from filter list
              scope.fields = $.grep(scope.fields, function (el) {
                return el.type !== 'heading'
              })

              // var for new field selection
              scope.filterState = {newField: '_select'}

              // Populate conditions from saved filter
              var filterKey = attrs.persistFilter ? 'filter_' + attrs.persistFilter : null
              if (filterKey && $rootScope[filterKey]) {
                $.each($rootScope[filterKey], function (i, condition) {
                  if (!condition.locked) {
                    // Only remember conditions that can actually be removed
                    scope.conditions.push(condition)
                  }
                })
                $rootScope[filterKey] = null
              }

              // Fixed conditions added here.
              // TODO: This is where we would load saved searches and conditions somehow too
              if (scope.conditions.length === 0) {
                scope.conditions.push({
                  field: 'active',
                  verb: 'a4boolequals',
                  value: 'yes',
                })
              }
            }
          },
          true,
        )

        scope.formatData = function (data, col) {
          if (typeof data == 'boolean') {
            return data ? '<span class="glyphicon glyphicon-ok" />' : ''
          } else if (scope.fieldHash[col] && scope.fieldHash[col].type == 'date' && data) {
            return _.date(data)
          } else {
            return data
          }
        }

        // Some columns (e.g. date_created, date_approved, date_deleted) are READONLY fields, which
        // the API returns nested under member.meta_ instead of directly on the member object.
        scope.getColumnValue = function (member, col) {
          if (col === 'date_created' && member.meta_ && member.meta_.date_approved) {
            // "Member added" (date_created): for members who came through an application, the date
            // they actually became a member is date_approved, not date_created (application date) -
            // matches the a4daterange filter logic on the backend.
            return member.meta_.date_approved
          }

          if (member[col] !== undefined) {
            return member[col]
          }
          return member.meta_ ? member.meta_[col] : undefined
        }

        /* This is used for all select2 autocomplete fields that need to make an ajax request */

        var select2Transport = function (queryParams) {
          scope.$apply(function () {
            var result = $http.post(queryParams.url, queryParams.data).success(function (d) {
              queryParams.success(d)
            })

            result.abort = function () {
              return null
            }

            return result
          })
        }

        scope.select2Options = {
          minimumInputLength: 2,
          width: 350,
          placeholder: _('placeholder_multiautocomplete_person'),
          multiple: true,
          search_field: 'id',
          display_field: 'fullname_',
          ajax: {
            url: CONFIG.url.members.api('quicksearch'),
            dataType: 'json',
            type: 'POST',
            transport: select2Transport,
            data: function (term, page) {
              return JSON.stringify({term: term, deleted: !!attrs.deleted, show_all: true}) // Convert deleted parameter string to boolean
            },
            results: function (data, page) {
              $.each(data.results, function (idx, member) {
                // html escape fullname_, because select2 treats the text as html
                member.fullname_ = $('<div/>').text(member.fullname_).html()
                if (!member.active) {
                  member.fullname_ += ` (${_('members_inactive')})`
                }
              })
              return {results: data.results, more: false}
            },
            params: {contentType: 'application/json;charset=utf-8'},
          },
          formatResult: function (item) {
            return item.fullname_
          },
          formatSelection: function (item) {
            return item.fullname_
          },
        }

        var prevFilterText = ''
        var requestId = 0

        // Reload the query set with the current filter
        scope.getMembers = function () {
          var api_method
          if (attrs.resultsOnly) {
            api_method = 'results'
          } else {
            api_method = 'query'
          }

          // make a copy (don't mess the scope)
          var filter = jQuery.extend(true, [], scope.conditions)

          // Don't send values for unary verbs
          const removeValueFromUnaryVerbs = (f) => {
            const fieldInfo = scope.fieldHash[f.field]
            if (fieldInfo && getVerbHash(fieldInfo.type)[f.verb] && getVerbHash(fieldInfo.type)[f.verb].unary) {
              delete f.value
            } else if (f.field === 'FILTER_OR') {
              // If this is a FILTER_OR condition, remove values from sub-conditions
              for (const subCond of f.value) {
                removeValueFromUnaryVerbs(subCond)
              }
            }
          }
          for (const f of filter) {
            removeValueFromUnaryVerbs(f)
          }

          //Don't send anything where value === "" (to avoid flashing when a new condition is added)
          filter = jQuery.grep(filter, function (cond) {
            if (cond.verb === 'a4daterange') {
              return cond.value && (cond.value.from || cond.value.to)
            }
            return cond.value !== ''
          })

          // Workaround for partly typing in a date
          filter = filter.filter(
            (f) => !((f.verb === 'lte' || f.verb === 'gte') && (f.value === 'INVALID' || f.value === null)),
          )

          if (attrs.persistFilter) {
            $rootScope['filter_' + attrs.persistFilter] = jQuery.extend(true, [], filter)
          }

          $rootScope.filter_to_post = jQuery.extend(true, [], filter)

          // Strips suffixes after '|' from values of all a4isoneof filters, including those nested under FILTER_OR
          // These are used with search-by-name select2 field, i.e. '123|John Doe'
          function stripPipeSuffixes(filterArray) {
            for (var i = 0; i < filterArray.length; i++) {
              var item = filterArray[i]
              if (/^!?a4isoneof$/.test(item.verb) && Array.isArray(item.value)) {
                for (var j = 0; j < item.value.length; j++) {
                  var idx = item.value[j].indexOf('|')
                  if (idx > 0) {
                    item.value[j] = item.value[j].substring(0, idx)
                  }
                }
              }
            }
          }
          stripPipeSuffixes($rootScope.filter_to_post)
          for (var i = 0; i < $rootScope.filter_to_post.length; i++) {
            var item = $rootScope.filter_to_post[i]
            if (item.field === 'FILTER_OR' && Array.isArray(item.value)) {
              stripPipeSuffixes(item.value)
            }
          }

          scope.$apply(function ($rootScope) {
            // This apply wrapper is due to a bug in 1.1.4 (https://github.com/angular/angular.js/issues/2438)

            var filterText = JSON.stringify($rootScope.filter_to_post)
            if (filterText === prevFilterText) {
              // filter hasn't changed since the previous run - don't re-run
              return
            }
            prevFilterText = filterText
            scope.stats = null // re-show throbber

            var thisRequestId = ++requestId

            Member[api_method](
              {
                filter: $rootScope.filter_to_post,
                deleted: !!attrs.deleted, // Convert deleted parameter string to boolean
                pending: !!attrs.pending,
                fetch_msg_stats: !!attrs.fetchMsgStats,
              },
              // success handler
              function (data) {
                if (thisRequestId !== requestId) {
                  // ignore outdated responses
                  return
                }
                scope.stats = data.stats || {}

                if (data.results) {
                  scope.members = data.results
                  scope.applySorting()

                  // Page stuff
                  scope.numberOfPages = Math.ceil(scope.members.length / scope.pageSize)
                  scope.currentPage = $rootScope.last_page > 0 ? $rootScope.last_page : 0
                  if (scope.currentPage + 1 > scope.numberOfPages) {
                    scope.currentPage = 0
                  }
                  $rootScope.last_page = null

                  if ($('.member-filter-wrapper .popover').length > 0 && $('.member-list-trigger').length > 0) {
                    $timeout(function () {
                      $('.member-filter-list').parent().get(0).scrollTop = $rootScope.memberFilterListScroll
                    }, 100)
                  }
                }

                a4.loaded(scope)
              },
              // error handler
              a4.restErrorFactory(scope),
            )
          })
        }

        // Watch for any changes in the filter, update the results set with a delay
        var fieldWatch = scope.$watch('fieldHash', function () {
          if (scope.fieldHash) {
            scope.$watch(
              'conditions',
              function (oldConds, newConds) {
                if ($('.member-filter-wrapper .popover').length > 0 && $('.member-list-trigger').length > 0) {
                  $timeout(function () {
                    $('.member-filter-wrapper .popover').css(
                      'top',
                      $('.member-list-trigger').position().top + $('.member-list-trigger').outerHeight(),
                    )
                  }, 1)

                  $rootScope.memberFilterListScroll = $('.member-filter-list').parent().scrollTop()
                }

                if (scope.conditions.length > 0) {
                  clearTimeout(actionTimer)

                  actionTimer = setTimeout(function () {
                    scope.getMembers()
                  }, 300)
                }
              },
              true,
            )
            fieldWatch()
          }
        })

        function getVerbs(fieldType, customVerb) {
          var v = []

          if (customVerb) {
            v.push(customVerb)
          } else {
            for (var i = 0; i < verbs.length; i++) {
              if (verbs[i]['for'][fieldType]) {
                v.push(verbs[i].name)
              }
            }
          }
          return v
        }

        function getVerbHash(fieldType, customVerb) {
          var v = {}
          for (var i = 0; i < verbs.length; i++) {
            if (customVerb && verbs[i]['name'] == customVerb) {
              v[verbs[i].name] = verbs[i]
            } else {
              if (verbs[i]['for'][fieldType]) {
                v[verbs[i].name] = verbs[i]
              }
            }
          }
          return v
        }

        // Set the default value to the first in the options list, or empty string
        function getDefaultValue(theField) {
          if (theField.verbs && theField.verbs[0] === 'a4daterange') {
            // "on välillä" needs {from, to} instead of a plain value
            return {from: '', to: ''}
          } else if (theField.type == 'multiselect') {
            return []
          } else {
            return theField.options ? theField.options[0].value : ''
          }
        }

        // Any date field can have "on välillä" (a4daterange, needs {from, to}) as one of its verbs,
        // alongside "on tämä tai aiempi/myöhempi" (lte/gte, needs a plain date). Reset the value only
        // when the shape actually changes, so switching between plain-date verbs (e.g. lte -> gte)
        // keeps the date the user already entered.
        scope.onVerbChange = function (condition) {
          var fieldInfo = scope.fieldHash[condition.field]
          if (!fieldInfo || !fieldInfo.verbs || fieldInfo.verbs.indexOf('a4daterange') === -1) {
            return
          }

          // Detect the {from, to} shape by its keys, not with a plain isObject() check: depending on
          // the AngularJS version, input[type=date] can bind a Date object, which is also an object.
          var needsRange = condition.verb === 'a4daterange'
          var value = condition.value
          var hasRange = angular.isObject(value) && ('from' in value || 'to' in value)
          if (needsRange === hasRange) {
            return
          }

          condition.value = needsRange ? {from: '', to: ''} : ''
        }

        scope.addCondition = function (conditions, fieldName, replaceIndex) {
          // A field was selected in the "newField" dropdown or passed as parameter. Find the correct field and add a new condition.
          fieldName = fieldName || scope.filterState.newField

          let newCondition
          if (fieldName === 'FILTER_OR') {
            newCondition = {
              id: Math.random(),
              field: fieldName,
              value: [],
            }
          } else {
            var theField = scope.fieldHash[fieldName]
            newCondition = {
              id: Math.random(),
              field: fieldName,
              verb: theField.verbs[0] || 'exact', // Set the default verb to the first one in the list, or exact
              value: getDefaultValue(theField),
            }
          }

          //If an index is passed then insert at that position, otherwise push to the end
          if (replaceIndex) {
            conditions.splice(replaceIndex, 0, newCondition)
          } else {
            conditions.push(newCondition)
          }

          scope.filterState.newField = '_select'
        }

        const findConditionsGroup = (conditionID) => {
          if (scope.conditions.find((c) => c.id == conditionID)) {
            return scope.conditions
          } else {
            // If the condition is not found, it might be in a sub-condition array
            return scope.conditions.find((c) => c.field === 'FILTER_OR' && c.value.find((c) => c.id === conditionID))
              ?.value
          }
        }
        // Find the first condition group that is a FILTER_OR}

        scope.removeCondition = function (conditionID) {
          // Find the condition to remove, remove it from the model.
          // First, find the correct conditions object.
          let conditions = findConditionsGroup(conditionID)

          for (var i = 0; i < conditions.length; i++) {
            if (conditions[i].id == conditionID) {
              conditions.splice(i, 1)
            }
          }
        }

        scope.editCondition = function (conditionID) {
          // If the field name changes, re-make the condition

          let conditions = findConditionsGroup(conditionID)

          for (var i = 0; i < conditions.length; i++) {
            if (conditions[i].id == conditionID) {
              var _newField = conditions[i].field
              conditions.splice(i, 1)
              scope.addCondition(conditions, _newField, i)
            }
          }
        }

        scope.userSpecifiedConditions = function (item) {
          return item.field !== 'active'
        }
      },
    }
  }])

angular.module('directives').directive('ng-blur', function () {
  return {
    restrict: 'A',
    link: function postLink(scope, element, attrs) {
      element.bind('blur', function () {
        scope.$apply(attrs.ngBlur)
      })
    },
  }
})

angular.module('directives').directive('invoiceStatus', function () {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: {status: '@', bouncemsg: '@'},
    template:
      '<span><span class="label {{statusClass}}" title="{{bouncemsg}}">{{statusTitle}} <span class="invoice-payment-delta">{{statusDelta}}</span></span> <img ng-show="status == \'queued\'" src="/r/static/img/small-loader.gif" /></span>',
    link: function (scope, element, attrs) {
      var status = scope.status.toLowerCase()
      var statusClasses = {
        pending: 'label-info',
        underpaid: 'label-warning',
        overdue: 'label-danger',
        paid: 'label-success',
        overpaid: 'label-overpaid',
        cancelled: 'label-default',
        bounced: 'label-danger',
        credited: 'label-default',
        combosettled: 'label-default',
        creditinvoice: 'label-default',
      }
      scope.statusClass = statusClasses[status]
      scope.statusTitle = _('invoice_status_' + status)
      if ((status == 'underpaid' || status == 'overpaid') && attrs.delta) {
        scope.statusDelta = '(' + attrs.delta + ' €)'
      }
    },
  }
})

angular.module('directives').directive('announcementStatus', function () {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: {status: '@'},
    template:
      '<span class="label {{statusClass}}">{{statusText}} <img ng-if="statusClass == \'label-default\'" src="/r/static/img/small-loader-dark.gif" /></span>',
    link: function (scope, element, attrs) {
      var media = attrs.media
      var statusData = {
        queued: {
          cls: 'label-default',
          text: _('announcement_status_sending'),
        },
        sent: {
          cls: 'label-info',
          text: media == 'sms' ? _('common_sms_status_sent') : _('announcement_status_unknown'),
        },
        confirmed: {
          cls: 'label-success',
          text: media == 'sms' ? _('common_sms_status_confirmed') : _('announcement_status_read'),
        },
        cancelled: {
          cls: 'label-danger',
          text: _('announcement_status_cancelled'),
        },
        bounced: {
          cls: 'label-danger',
          text: media == 'sms' ? _('common_sms_status_bounced') : _('announcement_status_bounced'),
        },
      }
      var status = attrs.status
      scope.statusText = statusData[scope.status.toLowerCase()].text
      scope.statusClass = statusData[scope.status.toLowerCase()].cls
    },
  }
})

angular.module('directives').directive('updreqStatus', function () {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: 'isolate',
    template:
      '<span class="label {{statusClass}}">{{statusText}} <img ng-if="statusClass == \'label-default\'" src="/r/static/img/small-loader-dark.gif" /></span>',
    link: function (scope, element, attrs) {
      var statusData = {
        pending: {
          cls: 'label-info',
          text: _('updreq_status_pending'),
        },
        updated: {
          cls: 'label-success',
          text: _('updreq_status_fixed'),
        },
        confirmed: {
          cls: 'label-success',
          text: _('updreq_status_ok'),
        },
      }

      var status = attrs.status
      scope.statusText = statusData[status.toLowerCase()].text
      scope.statusClass = statusData[status.toLowerCase()].cls
    },
  }
})

angular.module('directives').directive('msgStatus', ['$compile', function ($compile) {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: 'isolate',

    compile: function (element, attrs) {
      return function (scope, element, attrs) {
        var statusData = {
          bounced: {
            cls: 'glyphicon-remove-circle text-danger',
          },
          sent: {
            cls: 'glyphicon-circle-arrow-right text-info cursor-default',
          },
          confirmed: {
            cls: 'glyphicon-ok-circle text-success cursor-default',
          },
          cancelled: {
            cls: 'glyphicon-thumbs-down text-danger cursor-default',
          },
        }

        if (statusData[attrs.status.toLowerCase()] === undefined) {
          return
        }

        var $tpl = $('<span>', {
          class: 'glyphicon ' + statusData[attrs.status.toLowerCase()].cls,
          title: _('common_msg_status_' + attrs.media + '_' + attrs.status, {recipient: attrs.recipient}),
        })

        if (attrs.media === 'email' && attrs.status === 'bounced') {
          var bounce_msg = attrs.msg ? attrs.msg : _('bounce_message_default_text')
          var $a = $('<a>', {
            class: 'bounce-popover-trigger',
            href: 'javascript:void(0)',
            'data-placement': 'right',
            'data-trigger': 'click',
            'data-animation': false,
            'bs-popover': JSON.stringify({
              title:
                _('bounce_popover_title', {recipient: attrs.recipient}) +
                '<a ng-click="hide()" href="javascript:void(0)" class="button pull-right">x</a>',
              content: $('<span/>').text(bounce_msg).html().replace(/\n/g, '<br />'),
            }),
          })

          $tpl = $a.wrapInner($tpl)
        }

        $(element).parent().addClass('bounce-popover-wrapper')
        element.replaceWith($tpl)
        $compile($tpl)(scope)
      }
    },
  }
}])

angular.module('directives').directive('uptodateness', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      scope: 'isolate',
      replace: true,
      compile: function (element, attrs) {
        var popup = attrs.media == 'email' ? 'uptodateness-popup.html' : 'uptodateness-popup-sms.html'
        var statusData = {
          missing: {
            icon: 'warning-sign',
            badge: 'badge-warning',
          },
          unused: {
            icon: 'question-sign',
            badge: '',
          },
          sent: {
            icon: 'circle-arrow-right',
            badge: 'badge-info',
          },
          confirmed: {
            icon: 'ok-circle',
            badge: 'badge-success',
          },
          bounced: {
            icon: 'remove-circle',
            badge: 'badge-important',
          },
          unsupported: {
            icon: 'ban-circle',
            badge: 'badge-odd',
          },
        }
        return function (scope, element, attrs) {
          var tpl = $('<span>', {
            class: 'badge ' + statusData[attrs.status].badge,
            'data-placement': 'top',
            'data-trigger': 'hover',
            'bs-popover': "'/r/static/templates/partials/" + popup + "'",
          }).append(
            $('<span>', {
              class: 'glyphicon glyphicon-' + statusData[attrs.status].icon,
            }),
          )

          element.replaceWith(tpl)
          $compile(tpl)(scope)
        }
      },
    }
  },
])

angular.module('directives').directive('numberinput', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelController) {
      ngModelController.$parsers.push(function (data) {
        //convert data from view format to model format
        return String(data).replace(',', '.')
      })

      ngModelController.$formatters.push(function (data) {
        //convert data from model format to view format
        if (data) {
          return String(data).replace('.', ',')
        } else {
          return ''
        }
      })
    },
  }
})

angular.module('directives').directive('bounce', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      scope: 'isolate',
      replace: true,
      compile: function (element, attrs) {
        var classes

        if (attrs.label) {
          classes = 'label label-danger'
        } else {
          classes = 'badge badge-important'
        }

        return function (scope, element, attrs) {
          var tpl = $('<a>', {
            class: classes + ' bounce-popover-trigger',
            href: 'javascript:void(0)',
            'data-placement': 'right',
            'data-trigger': 'click',
            'bs-popover': JSON.stringify({
              title:
                _('bounce_popover_title') +
                '<a ng-click="hide()" href="javascript:void(0)" class="button pull-right">x</a>',
              content: $('<span/>').text(attrs.msg).html().replace(/\n/g, '<br />'),
            }),
            text: _('announcement_status_bounced'),
          })

          $(element).parent().addClass('bounce-popover-wrapper')
          element.replaceWith(tpl)
          $compile(tpl)(scope)
        }
      },
    }
  },
])

angular.module('directives').directive('mediaicon', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      replace: true,
      scope: 'isolate',
      compile: function (element, attrs) {
        var classes = {
          sms: 'glyphicon glyphicon-phone',
          letter: 'glyphicon glyphicon-envelope',
          pdf: 'glyphicon glyphicon-print',
          email: 'media-email',
          'email-small': 'media-email-small',
        }

        return function (scope, element, attrs) {
          var tpl = $('<span>', {
            class: classes[attrs.media],
            text: attrs.media === 'email' || attrs.media === 'email-small' ? '@' : '',
          })
          element.replaceWith(tpl)
          $compile(tpl)(scope)
        }
      },
    }
  },
])

angular.module('directives').directive('expensetypeicon', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      replace: true,
      scope: 'isolate',
      compile: function (element, attrs) {
        var classes = {
          km: 'glyphicon glyphicon-plane',
          per_diem: 'glyphicon glyphicon-cutlery',
        }
        return function (scope, element, attrs) {
          var tpl = $('<span>', {
            class: classes[attrs.expensetype],
          })
          element.replaceWith(tpl)
          $compile(tpl)(scope)
        }
      },
    }
  },
])

angular.module('directives').directive('expenseclaimstatus', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      replace: true,
      scope: 'isolate',
      compile: function (element, attrs) {
        var classes = {
          pending: 'label label-default',
          accepted: 'label label-success',
          rejected: 'label label-danger',
        }
        return function (scope, element, attrs) {
          var tpl = $('<span>', {
            class: classes[attrs.status],
            text: _('claim_status_' + attrs.status),
          })
          element.replaceWith(tpl)
          $compile(tpl)(scope)
        }
      },
    }
  },
])

angular.module('directives').directive('dateRange', function () {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: {datemin: '@', datemax: '@'},
    template: '<span>{{range}}</span>',
    link: function (scope, element, attrs) {
      scope.$watch('datemin+datemax', function () {
        var min = attrs.datemin instanceof Date ? attrs.datemin : new Date(Date.parse(attrs.datemin))
        var max = attrs.datemax instanceof Date ? attrs.datemax : new Date(Date.parse(attrs.datemax))
        if (min.toDateString() === max.toDateString()) {
          scope.range = _.date(min)
        } else {
          if (min.getYear() !== max.getYear()) {
            // if different year, print complete dates
            scope.range = _.date(min) + '—' + _.date(max)
          } else {
            // same year: at least day-of-month is different
            scope.range = min.getDate() + '.'
            if (min.getMonth() !== max.getMonth()) {
              // different month, too
              scope.range += 1 + min.getMonth() + '.'
            }
            scope.range += '—' + _.date(max)
          }
        }
      })
    },
  }
})

// NB! This is also in app (elapsedTime()) and server-side (elapsed_time)
angular.module('directives').directive('elapsedTime', function () {
  return {
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: {from: '@', to: '@'},
    template: '<span>{{elapsedTimeString}}</span>',
    link: function (scope, element, attrs) {
      scope.$watch('from+to', function () {
        var from = attrs.from instanceof Date ? attrs.from : new Date(Date.parse(attrs.from))
        var to = attrs.to instanceof Date ? attrs.to : new Date(Date.parse(attrs.to))

        // two dates ==> "3vrk 4h 20min"
        if (from && to) {
          var delta = to - from
          var totalMinutes = parseInt(delta / 1000 / 60)
          var days = Math.floor(totalMinutes / 60 / 24)
          var hours = Math.floor(totalMinutes / 60) % 24
          var minutes = totalMinutes % 60

          var ret = []
          if (days > 0) {
            ret.push('' + days + 'vrk')
          }
          if (hours > 0) {
            ret.push('' + hours + 'h')
          }
          if (minutes > 0) {
            ret.push('' + minutes + 'min')
          }
          scope.elapsedTimeString = ret.join(' ')
        } else {
          scope.elapsedTimeString = ''
        }
      })
    },
  }
})

angular.module('directives').directive('fmDisabled', [
  '$compile',
  '$location',
  '$timeout',
  function ($compile, $location, $timeout) {
    return {
      restrict: 'A',
      transclude: false,
      replace: true,
      link: function (scope, element, attrs) {
        var watcher = scope.$watch('settings', function () {
          if (!scope.settings) {
            return
          } else {
            watcher()
          }

          // Check the feature flag
          var flag = scope.settings.disable_[attrs.fmDisabled] || false
          if (!flag) {
            return
          }

          // Evaluate any secondary conditions for the disabling
          if (attrs.condition && !scope.$eval(attrs.condition)) {
            return
          }

          // Disable any inputs
          element.find('input,select,textarea,button').prop('disabled', true)
          element.find('.btn').addClass('disabled')
          element.addClass('disabled')

          if (element.prop('tagName') == 'INPUT' || element.prop('tagName') == 'BUTTON') {
            $timeout(function () {
              element.prop('disabled', true)
            }, 5000)
          } else if (element.prop('tagName') == 'A') {
            element.prop('href', '#')
          }

          // Change any texts to muted
          element
            .find('p,span,a')
            .not('.badge,.glyphicon,.popover-content,.uptodateness-wrapper')
            .addClass('text-muted')
          if (!element.hasClass('col-sm-7')) {
            element.addClass('text-muted')
          }

          var popover_attrs = {
            class: 'disabled-trigger',
            'data-placement': 'top',
            'data-trigger': 'hover',
            'bs-popover': JSON.stringify({
              title: _('disable_popover_title'),
              content: _('disable_popover_' + flag),
            }),
            html: '&nbsp;',
          }

          // Tooltip for explanation
          var $popover = $('<a>', popover_attrs)
          $popover.addClass('disabled-fake-link')
          element.parent().append($popover)

          $timeout(function () {
            $popover.css({
              left: element.position().left,
              top: element.position().top,
              width: element.outerWidth(),
              height: element.outerHeight(),
            })
          }, 3000)

          $compile(element.parent().find('.disabled-trigger'))(scope)
        })
      },
    }
  },
])

angular.module('directives').directive('onError', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.on('error', function () {
        element.attr('src', attr.onError)
      })
    },
  }
})

angular.module('directives').directive('bulkeditControls', [
  '$compile',
  '$location',
  '$timeout',
  function ($compile, $location, $timeout) {
    return {
      restrict: 'A',
      transclude: false,
      replace: true,
      link: function (scope, element, attrs) {
        if (!$location.path().match(/bulkedit/)) {
          return
        }

        // The name of the field
        var _field = attrs.bulkeditControls

        var $col = element.find('.col-sm-7,.bulk-col')

        // Show a message for fields that are not editable
        if ($.inArray(_field, scope.uneditable_fields) !== -1) {
          $timeout(function () {
            $col
              .children()
              .wrapAll('<div class="hide" />')
              .end()
              .append('<p class="form-control-static text-muted">' + _('bulkedit_field_not_editable') + '</p>')
          }, 1)
          return
        }

        var watcher = scope.$watch('bulkdata', function () {
          if (scope.bulkdata) {
            watcher() // Unwatch the watcher
            var _value

            var field_type = ''

            // Get the field type
            if (element.find('.form-control').attr('type') == 'text') {
              field_type = 'text'
            } else if (element.find('input[type="checkbox"]').length > 0) {
              field_type = 'checkbox'
            } else if (element.find('input[type="radio"]').length > 0) {
              field_type = 'radio'
            } else if (element.find('select').length > 0) {
              field_type = 'select'
            }

            // Set the current display value for the field
            if (scope.bulkdata[_field] === null) {
              _value = _('bulkedit_default_null')
            } else if (typeof scope.bulkdata[_field] == 'string') {
              if (scope.getFieldType(_field) == 'date') {
                _value = _.date(scope.bulkdata[_field])
              } else {
                _value = scope.bulkdata[_field]
              }
            } else if (scope.bulkdata[_field].multiple) {
              _value = _('bulkedit_default_multiple')
            } else if (typeof scope.bulkdata[_field] == 'boolean') {
              _value = scope.bulkdata[_field] ? true : false
              if (attrs['defaults']) {
                var _display_default = $.parseJSON(attrs['defaults'])[_value]
              }
            }

            // Add to the data hash
            scope.bulkfield_hash[_field] = {
              original: _value,
              originalDisplay: _display_default || _value,
              editing: false,
              element: element,
              type: field_type,
            }

            // If type is checkbox, radio or select, then add wrappers for the content which will be hidden, and the static default value
            if (field_type == 'checkbox' || field_type == 'select' || field_type == 'radio') {
              $col
                .children()
                .wrapAll('<div class="bulk-hide"/>')
                .end()
                .append(
                  $('<p>', {
                    class: 'bulk-static form-control-static',
                    text: scope.bulkfield_hash[_field].originalDisplay,
                  }),
                )
            }

            // Set the default value
            scope.toggleElement(_field)

            // Add the edit button
            var _btnClass = 'btn btn-info btn-bulkedit'
            if ($col.parents('.member-groups').length > 0) {
              _btnClass += ' btn-sm'
            }

            $col.addClass('bulkedit-wrap').append(
              $('<button>', {
                'data-alt-label': _('bulkedit_btn_revert'),
                class: _btnClass,
                'ng-click': "toggleEdit('" + _field + "')",
              })
                .append(
                  $('<span>', {
                    class: 'text',
                    text: _('bulkedit_btn_edit'),
                  }),
                )
                .append(' ')
                .append(
                  $('<span>', {
                    class: 'glyphicon glyphicon-edit',
                  }),
                ),
            )

            $compile(element.contents())(scope)
          }
        })
      },
    }
  },
])
